import { isSafeHttpUrl } from '../../utils/linkThumbnail';

export const ROGER_HOST =
  /^portal(?!-api)[a-z0-9-]*(\.preview)?\.(rogerhealthcare|rogercalls)\.com$/i;

export type TextPart =
  | { type: 'text'; text: string }
  | { type: 'link'; url: string; roger: boolean };

const URL_RE = /https?:\/\/[^\s<>]+/gi;
const TRAILING = /[.,;:!?)\]"']+$/;

export function isRogerUrl(url: string): boolean {
  try {
    return ROGER_HOST.test(new URL(url).hostname);
  } catch {
    return false;
  }
}

/** Split a plain run of text into text and web-address parts. */
export function splitLinks(text: string): TextPart[] {
  const parts: TextPart[] = [];
  let last = 0;
  const push = (t: string) => {
    if (!t) return;
    const prev = parts[parts.length - 1];
    if (prev?.type === 'text') prev.text += t;
    else parts.push({ type: 'text', text: t });
  };
  for (const match of text.matchAll(URL_RE)) {
    const start = match.index ?? 0;
    const url = match[0].replace(TRAILING, '');
    if (!isSafeHttpUrl(url)) continue;
    push(text.slice(last, start));
    parts.push({ type: 'link', url, roger: isRogerUrl(url) });
    last = start + url.length;
  }
  push(text.slice(last));
  return parts;
}
